var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';
var Match = function (props) {
    var timezone = moment.tz.guess();
    var startDate = moment(props.match.get('startDate')).tz(timezone).format('HH:mm');
    return (_jsxs("tr", __assign({ className: 'date-start show' }, { children: [_jsx("td", __assign({ className: 'timeTD' }, { children: startDate })), _jsxs("td", __assign({ className: 'eventTD' }, { children: [_jsx("span", __assign({ className: 'champ' }, { children: props.leagueName })), _jsx("span", __assign({ className: 'name' }, { children: props.match.get('name') }))] }))] })));
};
Match.propTypes = {
    match: PropTypes.object.isRequired,
    leagueName: PropTypes.string.isRequired
};
export default Match;



// WEBPACK FOOTER //
// ./src/components/grid/live/timetable/Match.jsx